import { connectRouter } from 'connected-react-router'
import { logoutSuccess } from 'data/auth/actions'
import { History } from 'history'
import { combineReducers, Reducer as ReduxReducer } from 'redux'
import { accountPageReducer } from 'scenes/Account/duck/reducers'
import { ACCOUNT_PAGE_STORE_ID } from 'scenes/Account/duck/types'
import { getType } from 'typesafe-actions'

import { flashNoticeReducer } from '../components/FlashNotice/duck/reducers'
import { FLASH_NOTICE_STORE_ID } from '../components/FlashNotice/duck/types'
import { dataReducer } from '../data/reducers'
import { dashboardReducer } from '../scenes/Dashboard/duck/reducers'
import { DASHBOARD_STORE_ID } from '../scenes/Dashboard/duck/types'
import { RootAction } from './actions'
import { InternalRootState, RootState } from './store'

function appReducerFactory(history: History<any>) {
  return combineReducers<RootState>({
    router: connectRouter(history),
    scenes: combineReducers<InternalRootState['scenes']>({
      [DASHBOARD_STORE_ID]: dashboardReducer,
      [ACCOUNT_PAGE_STORE_ID]: accountPageReducer,
    }),
    components: combineReducers<InternalRootState['components']>({
      [FLASH_NOTICE_STORE_ID]: flashNoticeReducer,
    }),
    data: dataReducer,
  })
}

export function rootReducerFactory(history: History<any>) {
  const appReducer = appReducerFactory(history)
  return (state: RootState | undefined, action: RootAction) => {
    const newState = action.type === getType(logoutSuccess) ? undefined : state
    return appReducer(newState, action)
  }
}

export type Reducer = ReduxReducer<RootState, RootAction>
